import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";

export function InvitePage() {
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<
    | { kind: "loading" }
    | { kind: "ready"; deepLink: string | null; expiresAt: number }
    | { kind: "used" }
    | { kind: "invalid" }
  >({ kind: "loading" });

  useEffect(() => {
    if (!token) return;
    api
      .lookupInvite(token)
      .then((r) => {
        if (!r.valid) {
          setState(r.usedAt ? { kind: "used" } : { kind: "invalid" });
        } else {
          setState({ kind: "ready", deepLink: r.botDeepLink, expiresAt: r.expiresAt });
        }
      })
      .catch(() => setState({ kind: "invalid" }));
  }, [token]);

  if (state.kind === "loading") {
    return <div className="page"><p className="big">Loading invite…</p></div>;
  }
  if (state.kind === "invalid") {
    return (
      <div className="page">
        <h1>Invite not found</h1>
        <p className="big">This invite link is invalid or has expired. Ask whoever sent it for a new one.</p>
      </div>
    );
  }
  if (state.kind === "used") {
    return (
      <div className="page">
        <h1>Invite already used</h1>
        <p className="big">
          This invite has already been redeemed. If that wasn't you, ask for a new one.
        </p>
      </div>
    );
  }
  return (
    <div className="page page-pad-bottom">
      <h1>Welcome to ourchess!</h1>
      <p className="big">
        Tap the button below. Telegram will open, you'll tap <b>Start</b>, and the bot
        will set up your account and send you a sign-in link.
      </p>
      {state.deepLink ? (
        <a className="btn" href={state.deepLink} style={{ width: "100%", marginTop: "0.5rem" }}>
          Open Telegram to join
        </a>
      ) : (
        <p className="muted">Bot deep link not configured. Tell the admin to set TELEGRAM_BOT_USERNAME.</p>
      )}
    </div>
  );
}
